import React, { useContext, useEffect, useState } from 'react'
import { FlagsSection } from './PatientFullDetailsCardComponents/FlagsSection'
import { FeedingChart } from '../Charts/FeedingChart'
import { useGetFlags } from '../CustomHooks/useGetFlags'
import { StarRating } from './PatientFullDetailsCardComponents/StarRating'
import { BiomarkersSection } from './PatientFullDetailsCardComponents/BiomarkersSection'
import { FormatMinAndSec, OfficialFormatDateWithYear } from '../../utilities/FormatDate'
import { PatientHeader } from './PatientFullDetailsCardComponents/PatientHeader'
import { PatientContext } from '../../data_layer/context/Patient/PatientContext'
import { useGetFeedingDetails } from '../CustomHooks/useGetFeedingDetails'
import { useGetBiomarkersListByPatientId } from '../CustomHooks/useGetBiomarkersListByPatientId'
import { useLocation } from 'react-router-dom'

export const PatientFullDetailsCard = ({
    index,
    feedingTimestamp,
    isComparingPatients
}) => {

    const { patients } = useContext(PatientContext);

    const { patient } = patients[index];

    const timestamp = feedingTimestamp || patients[index].currentFeedingTimestamp

    const { feeding } = useGetFeedingDetails(timestamp);

    const [granularity, setGranularity] = useState('full');

    const [showSuckSwallow, setShowSuckSwallow] = useState(true);
    const [showBreathing, setShowBreathing] = useState(true);
    const [showFlags, setShowFlags] = useState(true);

    const handleSuckSwallowToggle = () => {
        if (showSuckSwallow && !showBreathing) setShowBreathing(prev => !prev);
        setShowSuckSwallow(prev => !prev);
    };

    const handleBreathingToggle = () => {
        if (showBreathing && !showSuckSwallow) setShowSuckSwallow(prev => !prev);
        setShowBreathing(prev => !prev);
    };

    const { isLoading: loadingFlags, flags } = useGetFlags(timestamp);

    const { biomarkers, getBiomarkers } = useGetBiomarkersListByPatientId(patients[index]?.id);

    const { state } = useLocation();

    const changeGranularity = (event) => {
        setGranularity(event.target.value);
    }

    useEffect(() => {
        getBiomarkers();
    }, []);


    return (

        <div className="row mx-1 mt-1">
            <div className="col-lg-12 mb-2">

                <div className="w-100 rounded-3 bg-white px-0">
                    {/* <!-- Header --> */}
                    {
                        isComparingPatients &&
                        <PatientHeader
                            index={index}
                            isComparingPatients={isComparingPatients} />
                    }

                    <div className="row">
                        <div className="col-lg-4 pe-0 py-1">
                            {/* <!-- Content --> */}
                            <div className="d-flex">
                                <div className="px-3 w-100 d-flex align-items-stretch gap-4">

                                    <div className="d-flex flex-column patient-card-feeding-details-width">
                                        <p className="m-0 text-purple">Feeding details</p>

                                        <div className="row mt-1">
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Weight at feed</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{feeding?.weight != 0 ? `${feeding?.weight} ${feeding?.weight_uom}` : '-'}</p>
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Duration</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{FormatMinAndSec(feeding?.duration * 2)}</p>
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Vol. Cons</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{feeding?.consumption != 0 ? `${feeding?.consumption} ${feeding?.consumption_uom}` : '-'}</p>
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Vol. Planned</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{feeding?.volume != 0 ? `${feeding?.volume} ${feeding?.volume_uom}` : '-'}</p>
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Nipple</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{feeding?.nipple ? feeding?.nipple : '-'}</p>
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Nutrient</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{feeding?.nutrient_type ? feeding?.nutrient_type : '-'}</p>
                                            </div>
                                            <div className="col-6 py-1  mb-2">
                                                <p className="text-sm fw-semibold mb-0">Position</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{feeding?.position ? feeding?.position : '-'}</p>
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Paced</p>
                                                <p className="mb-0 lh-sm fw-semibold text-md">{!feeding?.paced || feeding?.paced === 0 ? 'No' : 'Yes'}</p>
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Readiness to feed ({feeding?.readiness_score}/5)</p>
                                                <StarRating rating={feeding?.readiness_score} />
                                            </div>
                                            <div className="col-6 py-1 mb-2">
                                                <p className="text-sm fw-semibold mb-0">Quality of feed ({feeding?.quality_score}/5)</p>
                                                <StarRating rating={feeding?.quality_score} />
                                            </div>

                                            {
                                                feeding?.note &&
                                                <div className="col-12 py-1">
                                                    <p className="text-sm fw-semibold mb-0">Comment</p>
                                                    <p className="mb-0 lh-sm fw-semibold text-md">{feeding?.note}</p>
                                                </div>
                                            }




                                        </div>
                                    </div>
                                    <BiomarkersSection biomarkers={biomarkers?.feedings?.find((feed) => feed.timestamp === feeding?.timestamp)?.biomarkers} />
                                    <FlagsSection flags={flags} />

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 py-2 px-4">
                            {/* <!-- Content --> */}
                            <div className="d-flex ps-4 w-100">
                                <div className="px-3 w-100 d-flex">
                                    <div className="d-flex flex-column w-100">
                                        <div className="d-flex w-100 justify-content-between m-0">
                                            <div className="d-flex m-0 gap-2">
                                                <p className="text-purple m-0">{OfficialFormatDateWithYear(feeding?.timestamp)}</p>
                                            </div>
                                            <div className="d-flex m-0 gap-3">
                                                {[
                                                    { checked: showSuckSwallow, onChange: handleSuckSwallowToggle, color: 'var(--neo-graph-pressure-color)', label: 'Suck-Swallow (suck ▲ swallow ▼)', textClass: 'text-green' },
                                                    { checked: showBreathing, onChange: handleBreathingToggle, color: 'var(--neo-graph-breathing-color)', label: 'Breathing (in ▼ out ▲)', textClass: 'text-blue' },
                                                    { checked: showFlags, onChange: () => setShowFlags(prev => !prev), color: 'var(--neo-graph-flags-color)', label: 'Flags', textClass: 'text-lilac' },
                                                ].map(({ checked, onChange, color, label, textClass }) => (
                                                    <label key={label} className="d-flex gap-2 align-items-center m-0" style={{ cursor: 'pointer' }}>
                                                        <span style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            width: 16,
                                                            height: 16,
                                                            border: `2px solid ${color}`,
                                                            borderRadius: 2,
                                                            backgroundColor: checked ? color : 'transparent',
                                                            flexShrink: 0,
                                                            position: 'relative',
                                                        }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={checked}
                                                                onChange={onChange}
                                                                style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%', cursor: 'pointer', margin: 0 }}
                                                            />
                                                            {checked && (
                                                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" style={{ pointerEvents: 'none' }}>
                                                                    <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            )}
                                                        </span>
                                                        <p className={`mb-0 text-base ${textClass} m-0`}>{label}</p>
                                                    </label>
                                                ))}
                                            </div>
                                            <div className="d-flex m-0">
                                                <p className='text-sm m-0'>
                                                    <select name="neo_date" id="" className="pe-1 ps-2 py-1 rounded-4 bg-gray" onChange={changeGranularity}>

                                                        <option value='full'>Full</option>
                                                        <option value='25m'>25 min</option>
                                                        <option value='10m'>10 min</option>
                                                        <option value='5m'>5 min</option>
                                                        <option value='1m'>1 min</option>
                                                        <option value='30s'>30 sec</option>
                                                        <option value='10s'>10 sec</option>

                                                    </select>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="w-full mt-1 overflow-x-scroll">
                                            <FeedingChart
                                                feeding={feeding}
                                                flags={flags}
                                                isLightGraph={false}
                                                granularity={granularity}
                                                showSuckSwallow={showSuckSwallow}
                                                showBreathing={showBreathing}
                                                showFlags={showFlags}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
